var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from '../baseApi';
export default class UsersApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'api/v1/users';
    }
    getAllUsers(environmentId_1, accountId_1, filters_1) {
        return __awaiter(this, arguments, void 0, function* (environmentId, accountId, filters, { signal } = {}) {
            return yield this.apiCall({
                method: 'GET',
                route: `${this.apiBasePath}/${environmentId}/${accountId}`,
                params: filters,
                signal,
            });
        });
    }
    createUser(environmentId_1, accountId_1, data_1) {
        return __awaiter(this, arguments, void 0, function* (environmentId, accountId, data, { signal } = {}) {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}/${environmentId}/${accountId}`,
                data,
                signal,
            });
        });
    }
    resendInvite(environmentId_1, accountId_1, userId_1) {
        return __awaiter(this, arguments, void 0, function* (environmentId, accountId, userId, { signal } = {}) {
            yield this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}/${environmentId}/${accountId}/${userId}/resend-invite`,
                signal,
            });
        });
    }
    updateUser(environmentId_1, accountId_1, userId_1, data_1) {
        return __awaiter(this, arguments, void 0, function* (environmentId, accountId, userId, data, { signal } = {}) {
            return yield this.apiCall({
                method: 'PUT',
                route: `${this.apiBasePath}/${environmentId}/${accountId}/${userId}`,
                data,
                signal,
            });
        });
    }
    enableUser(environmentId_1, accountId_1, userId_1) {
        return __awaiter(this, arguments, void 0, function* (environmentId, accountId, userId, { signal } = {}) {
            return yield this.apiCall({
                method: 'PUT',
                route: `${this.apiBasePath}/${environmentId}/${accountId}/${userId}/enable`,
                signal,
            });
        });
    }
    disableUser(environmentId_1, accountId_1, userId_1) {
        return __awaiter(this, arguments, void 0, function* (environmentId, accountId, userId, { signal } = {}) {
            return yield this.apiCall({
                method: 'PUT',
                route: `${this.apiBasePath}/${environmentId}/${accountId}/${userId}/disable`,
                signal,
            });
        });
    }
    deleteUser(environmentId_1, accountId_1, userId_1) {
        return __awaiter(this, arguments, void 0, function* (environmentId, accountId, userId, { signal } = {}) {
            yield this.apiCall({
                method: 'DELETE',
                route: `${this.apiBasePath}/${environmentId}/${accountId}/${userId}`,
                signal,
            });
        });
    }
}
//# sourceMappingURL=index.js.map